<template>
<div>
  <div class="">
  </div>
  <LogisticsCard></LogisticsCard>
</div>
  
</template>
<script>
import LogisticsCard from "./components/LogisticsCard";
export default {
   components: {
    LogisticsCard,
  },
  data() {
    return{

    }
  },

}
</script>
<style scoped>

</style>